var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullWidth"},[_c('template-preview',{attrs:{"templateKey":_vm.templateKey,"single":"true","dataView":_vm.dataView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }